import { CONDITION_TYPE, VALIDATE } from '@cognitiv/cicada-ui';
import { JobState } from 'ducks/job/slices';
import { StopJobPayload } from 'ducks/types/payload-types';

export const edit_job_default_state: JobState = {
  batch_descriptor: '',
  batch_id: null,
  description: '',
  docker_image: '',
  duration_seconds: null,
  job_definition_id: null,
  job_definition_name: '',
  job_id: null,
  job_name: '',
  job_state_id: null,
  job_state_name: '',
  max_retries: null,
  organization_id: null,
  organization_name: '',
  project_id: null,
  project_name: '',
  cpu: null,
  gpu: null,
  memory_gb: null,
  shared_memory_mb: null,
  storage_gb: null,
  startup_command: '',
  result_method_id: null,
  result_method_name: '',
  retries: null,
  prevent_preemption_name: 'No',
  prevent_preemption: false,
  created_by: '',
  start_datetime_utc: '',
  finish_datetime_utc: '',
  timeout_seconds: 0,
  stdout_success_text: '',
  batch_name: '',
  billing_identifier: '',
  location_group_id: 0,
  location_group_name: '',
  cpu_architecture_id: 0,
  cpu_architecture_name: '',
  compute_hours_estimate: 0,
  compute_cost_estimate: 0,
  job_sort: '',
  timeout_percentage: null,
  timeout_seconds_masked: '',
  duration_days_show: false,
  duration_hours_show: false,
  duration_minutes_show: false,
  duration_days_masked: '',
  duration_hours_masked: '',
  duration_minutes_masked: '',
  duration_seconds_masked: '',
  docker_image_formatted: { registry: '', repository: '', tag: '' },
  job_state_name_formatted: '',
  sort_datetime_utc: '',
  start_datetime_utc_formatted: '',
  finish_datetime_utc_formatted: '',
  sort_datetime: '',
  start_datetime_formatted: '',
  finish_datetime_formatted: '',
  uuid: '',
};

export const stop_job_default_state: StopJobPayload = {
  message: '',
};

export const stop_job_validation = {
  message: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Email Address is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};

export const edit_job_validate = {
  batch_descriptor: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Batch Descriptor is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  timeout_seconds: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Timeout is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
      {
        error: 'Timeout Exceeds Max Limit',
        type: CONDITION_TYPE.LESS_THAN,
        values: [2147483647],
      },
      {
        error: 'Timeout Exceeds Min Limit',
        type: CONDITION_TYPE.GREATER_THAN,
        values: [-1],
      },
    ],
  },
};
